import LockerCardCarrierBadge from "@components/Lockers/LockerCard/LockerCardCarrierBadge";
import LockerCardRoutingAction from "@components/Lockers/LockerCard/LockerCardRoutingAction";

import LockerCardPositionInfo from "@components/Lockers/LockerCard/LockerCardPositionInfo";
import LockerCardName from "@components/Lockers/LockerCard/LockerCardName";
import LockerCardAddress from "@components/Lockers/LockerCard/LockerCardAddress";
import LockerCardInactiveTag from "@components/Lockers/LockerCard/LockerCardInactiveTag";

const LockerInfoWindowHeader = ({ marker }) => (
  <LockerCardCarrierBadge locker={marker} />
);

const LockerInfoWindowContent = ({ marker }) => (
  <div className="mt-[6px] space-y-[4px] text-[14px]">
    <LockerCardName locker={marker} />
    <LockerCardAddress locker={marker} />

    <LockerCardInactiveTag locker={marker} />

    {marker.description && (
      <div className="pt-[4px] text-[12px] text-gray-1600">
        <LockerCardPositionInfo locker={marker} />
      </div>
    )}

    <div className="pt-[8px] text-left">
      <LockerCardRoutingAction locker={marker} />
    </div>
  </div>
);

export { LockerInfoWindowHeader, LockerInfoWindowContent };
